import styled from 'styled-components';

import { colors } from 'global/colors';

export const ContentContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;

  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

export const ChallengeLabel = styled.span`
  text-transform: uppercase;
  color: ${colors.gray2};
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 10px;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-start;
`;
